import { useState } from "react";
import { X, Search, Bell, Sparkles, LayoutGrid } from "lucide-react";

const KEY = "radarx_welcome_dismissed_v1";

export default function WelcomeBanner({ user, onExplore = () => {} }) {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
  });

  if (dismissed) return null;

  const close = () => {
    try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    setDismissed(true);
  };

  const firstName = (user?.name || user?.email || "").split(/[@ ]/)[0];

  const steps = [
    { icon: LayoutGrid, title: "Explore os perfis", text: "Veja fotos, descrições e contactos numa galeria visual." },
    { icon: Search, title: "Pesquise por IA", text: "Descreva o que procura em linguagem natural." },
    { icon: Sparkles, title: "Deteção de duplicados", text: "Números e fotos repetidos são agrupados automaticamente." },
    { icon: Bell, title: "Alertas diários", text: "Saiba quem é novo e quem reapareceu, todos os dias." },
  ];

  return (
    <div className="relative bg-gradient-to-br from-[#1a160e] via-[#18181b] to-[#18181b] border border-[#c8aa6e]/30 p-6 overflow-hidden" data-testid="welcome-banner">
      <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-[#c8aa6e]/10 blur-2xl pointer-events-none z-0" />
      <button
        type="button"
        onClick={close}
        data-testid="welcome-dismiss"
        aria-label="Fechar boas-vindas"
        className="absolute top-3 right-3 z-20 text-[#71717a] hover:text-[#fafafa] p-1"
      >
        <X className="w-5 h-5" />
      </button>

      <div className="relative">
        <div className="inline-flex items-center gap-1.5 text-[10px] tracking-widest uppercase text-[#c8aa6e] border border-[#c8aa6e]/40 px-2 py-0.5 mb-3">
          <Sparkles className="w-3 h-3" /> Bem-vindo{firstName ? `, ${firstName}` : ""}
        </div>
        <h2 className="font-head text-2xl sm:text-3xl font-light text-[#fafafa] leading-tight">
          O seu radar de anúncios, <span className="text-[#c8aa6e]">num só painel</span>.
        </h2>
        <p className="text-sm text-[#a1a1aa] mt-2 max-w-2xl">
          Este é o seu dashboard de gestão de informação. Os dados de vários sites são recolhidos
          automaticamente todos os dias — só tem de explorar, pesquisar e acompanhar novidades.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-5">
          {steps.map((s) => (
            <div key={s.title} className="bg-[#09090b]/60 border border-[#27272a] p-3">
              <s.icon className="w-4 h-4 text-[#c8aa6e]" strokeWidth={1.5} />
              <div className="text-sm text-[#fafafa] mt-2">{s.title}</div>
              <div className="text-[11px] text-[#71717a] mt-0.5 leading-snug">{s.text}</div>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-3 mt-5">
          <button
            type="button"
            onClick={onExplore}
            data-testid="welcome-explore"
            className="bg-[#c8aa6e] text-black hover:bg-[#d4b982] px-4 py-2.5 text-sm font-medium flex items-center gap-2 transition-colors"
          >
            <LayoutGrid className="w-4 h-4" /> Explorar perfis
          </button>
          <button
            type="button"
            onClick={close}
            className="text-sm text-[#a1a1aa] hover:text-[#fafafa] px-2 py-2"
          >
            Dispensar
          </button>
        </div>
      </div>
    </div>
  );
}
